"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/health/v1/cms_service.proto (package spwn.health.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSHealthServiceGetHealthResponse = exports.CMSHealthServiceGetHealthRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.health.v1.CMSHealthServiceGetHealthRequest
 */
class CMSHealthServiceGetHealthRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sentence = 1;
         */
        this.sentence = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSHealthServiceGetHealthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSHealthServiceGetHealthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSHealthServiceGetHealthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSHealthServiceGetHealthRequest, a, b);
    }
}
exports.CMSHealthServiceGetHealthRequest = CMSHealthServiceGetHealthRequest;
CMSHealthServiceGetHealthRequest.runtime = protobuf_1.proto3;
CMSHealthServiceGetHealthRequest.typeName = "spwn.health.v1.CMSHealthServiceGetHealthRequest";
CMSHealthServiceGetHealthRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sentence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.health.v1.CMSHealthServiceGetHealthResponse
 */
class CMSHealthServiceGetHealthResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sentence = 1;
         */
        this.sentence = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSHealthServiceGetHealthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSHealthServiceGetHealthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSHealthServiceGetHealthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSHealthServiceGetHealthResponse, a, b);
    }
}
exports.CMSHealthServiceGetHealthResponse = CMSHealthServiceGetHealthResponse;
CMSHealthServiceGetHealthResponse.runtime = protobuf_1.proto3;
CMSHealthServiceGetHealthResponse.typeName = "spwn.health.v1.CMSHealthServiceGetHealthResponse";
CMSHealthServiceGetHealthResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sentence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=cms_service_pb.js.map